export default "__VITE_ASSET__CQ2ukfy0__"